// src/Register.js
import React, { useState } from "react";
import API_BASE_URL from "./apiConfig";

function Register({ onRegistered, onToggle }) {
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
  const res = await fetch(`${API_BASE_URL}/login-api/register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ correo, password }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess("Registrado correctamente. Ya puedes iniciar sesión.");
        setError("");
        if (onRegistered) onRegistered();
      } else {
        setError(data.message || "Error al registrar");
      }
    } catch (err) {
      setError("Error en la conexión");
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-800 via-red-900 to-gray-900 text-white p-6">
      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-2xl w-full max-w-md border border-red-400/30 transform transition duration-500 hover:scale-[1.02] hover:shadow-red-500/40">
        
        {/* Encabezado con logo */}
        <div className="flex flex-col items-center mb-6">
          <img
            src="/images/fe5.png"
            alt="Logo Element5"
            className="w-20 h-20 object-contain drop-shadow-lg"
          />
          <h2 className="text-3xl font-extrabold mt-4 text-white">
            Crear cuenta
          </h2>
          <p className="text-gray-300 text-sm mt-1">
            Regístrate con tu correo <span className="text-red-400">@element5.mx</span>
          </p>
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-100 text-sm font-semibold mb-1">
              Correo electrónico
            </label>
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              className="w-full px-4 py-3 bg-white/20 border border-red-400/40 rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400 transition-all"
              placeholder="usuario@element5.mx"
              required
            />
          </div>

          <div>
            <label className="block text-gray-100 text-sm font-semibold mb-1">
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-white/20 border border-red-400/40 rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400 transition-all"
              placeholder="••••••••"
              required
            />
          </div>

          {/* Mensajes */}
          {error && (
            <div className="bg-red-700/30 border border-red-500 text-red-300 px-3 py-2 rounded-lg text-sm">
              {error}
            </div>
          )}
          {success && (
            <div className="bg-green-700/30 border border-green-500 text-green-300 px-3 py-2 rounded-lg text-sm">
              {success}
            </div>
          )}

          {/* Botón de registro */}
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-gradient-to-r from-red-600 to-red-400 text-white font-semibold text-lg shadow-md hover:from-red-500 hover:to-red-300 transition-all duration-300 hover:shadow-red-400/50"
          >
            Registrarme
          </button>

          {/* Enlace para cambiar a login */}
          <div className="text-center mt-4 text-gray-300 text-sm">
            ¿Ya tienes una cuenta?{" "}
            <button
              type="button"
              onClick={() => onToggle && onToggle()}
              className="text-red-400 hover:text-red-300 hover:underline font-semibold"
            >
              Inicia sesión
            </button>
          </div>
        </form>

        {/* Pie de página */}
        <div className="mt-6 text-center text-gray-400 text-xs">
          © {new Date().getFullYear()} Element5 | Sistema Empresarial
        </div>
      </div>
    </div>
  );
}

export default Register;
